import React, { ReactNode, useEffect, useRef, useState } from "react"
import { twJoin } from "tailwind-merge"
import Icon from "@components/UI/Icon"

type CollapseProps = {
  title: string
  children: ReactNode
  isOpen: boolean
  onToggle: () => void
  className?: string
  titleClassName?: string
  iconClassName?: string
  contentClassName?: string
  theme?: string
}

export const Collapse = ({ title, children, isOpen, onToggle, className, titleClassName, iconClassName, contentClassName, theme }: CollapseProps) => {
  const contentRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight)
    } else {
      setHeight(0)
    }
  }, [isOpen])

  return (
    <div className={twJoin(className, "overflow-hidden")}>
      <button
        className={twJoin(
          "flex flex-row justify-between items-center w-full",
          "text-20p font-600 text-white",
          "py-16p",
          titleClassName
        )}
        onClick={onToggle}
      >
        <span>{title}</span>
        <Icon
          name={"arrow3-right"}
          color={theme==="neutral" ? "neutral-700" : "neutral-100"}
          className={twJoin("[&_path]:fill-white", "w-24p h-24p", !isOpen ? "rotate-90" : "rotate-[270deg]", iconClassName)}
          size={24}
        />
      </button>
      <div
        className={twJoin("overflow-hidden transition-[height] duration-300", "border-b border-neutral-700", contentClassName)}
        style={{ height: isOpen ? `${height}px` : "0px" }}
      >
        <div ref={contentRef}>{children}</div>
      </div>
    </div>
  )
}

export const CollapseGroup = ({ items }: { items: { title: string; content: ReactNode }[] }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <div>
      {items.map((item, index) => (
        <Collapse
          key={index}
          title={item.title}
          isOpen={openIndex === index}
          onToggle={() => setOpenIndex(openIndex === index ? null : index)}
        >
          {item.content}
        </Collapse>
      ))}
    </div>
  )
}
